import React, { useState } from "react";
import styled from "styled-components";
import { lightGreys } from "../../../styles";
import { CompassParagraph } from "../styledComponents";
import { CompassTextarea, CompassInput } from "../styledComponents";
import { ToggleOptionsButton } from "../../buttons/ToggleOptionsButton";
import {
  ElementContainer,
  RowContainer,
  ColumnContainer,
  FlexibleContainer,
} from "../../containers/styledComponents";
import { NoteViewer } from "./NoteViewer";
import { Content } from "../ContentBox";

const NoteTextarea = styled(CompassTextarea)`
  box-sizing: border-box;
  width: 100%;
  margin-right: 0;
`;

const TitleInput = styled(CompassInput)`
  box-sizing: border-box;
  width: 100%;
  margin-right: 0;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${lightGreys.borderLightGrey};
  font-family: "ApercuMedium";
  font-size: 15px;
`;

export interface NoteEditorProps {
  note: Content;
  onChange: (updated: Content) => void;
  contentMinHeight?: string;
  contentMaxHeight?: string;
}

export const NoteEditor: React.FC<NoteEditorProps> = ({
  note,
  onChange,
  contentMinHeight,
  contentMaxHeight,
}) => {
  const [isMarkdownPreview, setIsMarkdownPreview] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    source: "title" | "content",
  ): void => {
    onChange({ ...note, [source]: e.target.value });
  };

  return (
    <>
      <RowContainer mb={1}>
        <ColumnContainer mt={1}>
          <RowContainer mb={1}>
            <FlexibleContainer ml={"5px"}>
              <CompassParagraph bold={true}>Title</CompassParagraph>
            </FlexibleContainer>
          </RowContainer>
          <RowContainer mb={1} mt={3}>
            <TitleInput
              value={note.title}
              onChange={(e): void => handleChange(e, "title")}
            />
          </RowContainer>
        </ColumnContainer>
      </RowContainer>
      <RowContainer mt={5}>
        <ColumnContainer mt={1}>
          <RowContainer mb={1}>
            <FlexibleContainer ml={"5px"}>
              <ElementContainer ai="center" jc="space-between">
                <CompassParagraph bold={true}>Content</CompassParagraph>
                <ToggleOptionsButton
                  options={["Edit", "Preview"]}
                  handleOptionChange={(option): void =>
                    setIsMarkdownPreview(option === "Preview")
                  }
                />
              </ElementContainer>
            </FlexibleContainer>
          </RowContainer>
          <RowContainer mb={1} mt={3}>
            {isMarkdownPreview ? (
              <NoteViewer
                content={note.content}
                emptyText="Nothing to preview"
                minHeight={contentMinHeight}
                maxHeight={contentMaxHeight}
              />
            ) : (
              <NoteTextarea
                mr={0}
                value={note.content}
                onChange={(e): void => handleChange(e, "content")}
              />
            )}
          </RowContainer>
        </ColumnContainer>
      </RowContainer>
    </>
  );
};
